import { Injector } from '@angular/core';
// must be deep as jest will somehow fuck up finding its global constants for core-shared (IS_PRODUCTION error)
import { subscriptionCount } from '@core/shared/utils/rxjs/subscription-count';
import { BehaviorSubject, Subject } from 'rxjs';
import { AppMessage } from '../message/app-message.class';
import { GLOBAL_MESSAGE_HANDLER_TOKEN } from './global-message-handler.token';
import * as i0 from "@angular/core";
export let MessageHandlerClass = /*#__PURE__*/(() => {
  class MessageHandlerClass {
    constructor(injector) {
      this.injector = injector;
      this.messageSource = new Subject();
      this.messageSubscriberCount = new BehaviorSubject(0);
      this.clearSource = new Subject();
      this.messageObserver = this.messageSource.asObservable().pipe(
      // count number of subscriptions so that the logic can determine if it is actually able to display anything
      subscriptionCount(this.messageSubscriberCount));
      this.clearObserver = this.clearSource.asObservable();
      this.add = this.push;
    }
    canDisplayMessages() {
      return this.messageSubscriberCount.value > 0;
    }
    create(messageData) {
      const m = new AppMessage(this.injector);
      typeof messageData !== 'undefined' && messageData !== null && m.setMessage(messageData);
      return m;
    }
    push(messages) {
      if (messages) {
        if (this.canDisplayMessages()) {
          let messageArr = !Array.isArray(messages) ? [messages] : messages;
          if (messageArr.length) {
            messageArr = messageArr.map(val => val instanceof AppMessage ? val : this.create(val));
            this.messageSource.next(messageArr);
          }
        } else {
          if (this.isGlobal) {
            console.error('GlobalMessageHandlerService display failure: No message outlet component is available! Incoming messages:', messages);
          } else {
            // pass message up to global handler
            const global = this.injector.get(GLOBAL_MESSAGE_HANDLER_TOKEN);
            global.push(messages);
          }
        }
      }
    }
    createAndDisplay(messageData) {
      const m = this.create(messageData);
      // only register self as handler if able to actually display the message!
      if (this.canDisplayMessages()) m.setHandler(this);
      return m;
    }
    clear(key) {
      this.clearSource.next(key || null);
    }
    static {
      this.ɵfac = function MessageHandlerClass_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MessageHandlerClass)(i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: MessageHandlerClass,
        factory: MessageHandlerClass.ɵfac
      });
    }
  }
  return MessageHandlerClass;
})();
export let GlobalMessageHandlerService = /*#__PURE__*/(() => {
  class GlobalMessageHandlerService extends MessageHandlerClass {
    constructor() {
      super(...arguments);
      this.isGlobal = true;
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵGlobalMessageHandlerService_BaseFactory;
        return function GlobalMessageHandlerService_Factory(__ngFactoryType__) {
          return (ɵGlobalMessageHandlerService_BaseFactory || (ɵGlobalMessageHandlerService_BaseFactory = i0.ɵɵgetInheritedFactory(GlobalMessageHandlerService)))(__ngFactoryType__ || GlobalMessageHandlerService);
        };
      })();
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: GlobalMessageHandlerService,
        factory: GlobalMessageHandlerService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return GlobalMessageHandlerService;
})();
/**
 * LocalMessageHandlerService is used if you want to display app messages in a local <app-messages /> Component instead of global message toast.
 * Note that it must be provided on component level to function as expected!
 * (else, when using several <app-messages> in parallel, each of them would display all messages as there's only one handler instance.)
 */
export let LocalMessageHandlerService = /*#__PURE__*/(() => {
  class LocalMessageHandlerService extends MessageHandlerClass {
    constructor() {
      super(...arguments);
      this.isGlobal = false;
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵLocalMessageHandlerService_BaseFactory;
        return function LocalMessageHandlerService_Factory(__ngFactoryType__) {
          return (ɵLocalMessageHandlerService_BaseFactory || (ɵLocalMessageHandlerService_BaseFactory = i0.ɵɵgetInheritedFactory(LocalMessageHandlerService)))(__ngFactoryType__ || LocalMessageHandlerService);
        };
      })();
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: LocalMessageHandlerService,
        factory: LocalMessageHandlerService.ɵfac
      });
    }
  }
  return LocalMessageHandlerService;
})();